export default __webpack_public_path__ + "static/wafd-treasury-app-qr-24af096850c62b605aed99321961ed83.svg";